<template>
  <div class="container-fluid container-wrap col-sm-12 col-xs-12">
    <div class="row justify-content-center">
      <div class="col-sm-12 col-xs-12">
        <div class="card-header pb-0 col-sm-12 d-flex mainDiv">
          <div class="col-sm-12 col-xs-12">
            <div
                class="col-sm-12 col-xs-12 titleDiv CertListTitle justify-content-between title-area"
            >
              <div style="display: flex; justify-content: space-between; align-items: flex-start; width: 100%;">
                <div>
                  <h3>{{ $t('certificatelist_header_title') }}</h3>
                  <h5>{{ `${$t('certificatelist_header_desc1')} ${certificateText} ${$t('certificatelist_header_desc2')}` }}</h5>
                </div>
                <a-button
                  v-if="prevPage"
                  @click="goBack"
                  size="small"
                >
                  <template #icon><ArrowLeftOutlined /></template>
                  뒤로가기
                </a-button>
              </div>
            </div>
            <div class="card-body px-0 pt-0 pb-2 table-with-search">
              <div class="search-filter-container table-info-filter">
                    <div class="search-filter-row">
                        <div class="search-filter-title">
                            {{ $t('common_searchfilter_keyword') }}
                        </div>
                        <div class="search-filter-content">
                            <div class="mobile-wrap">
                                <a-select 
                                    v-model:value="searchFilter.filter"
                                    size="small"
                                    style="width: 150px;"
                                >
                                    <a-select-option value="">{{ $t('hospital_search_all') }}</a-select-option>
                                    <!-- <option value="name">환자명</option>
                                    <option value="mobile">전화번호</option>
                                    <option value="warrantyName">인증서명</option> -->
                                    <a-select-option value="hospitalName">{{ $t('hospital_search_hospital') }}</a-select-option>
                                    <a-select-option value="cNo">{{ $t('hospital_search_cno') }}</a-select-option>
                                </a-select>
                                <a-input 
                                    size="small"
                                    v-model:value="searchFilter.keyword"
                                    @keyup.enter="search"
                                    :placeholder="$t('common_searchfilter_placeholder')"
                                >
                                  <template #prefix>
                                    <i
                                        class="fa-regular fa-magnifying-glass"
                                    />
                                  </template>
                                </a-input>

                            </div>
                            <div class="mobile-wrap">
                                <a-button
                                    class="black"
                                    size="small"
                                    @click="search"
                                >
                                    {{ $t('certificatelist_search') }}
                                </a-button>
                                <a-button
                                    @click="initFilter"
                                    size="small"
                                >
                                {{ $t('common_searchfilter_reset') }}
                                </a-button>
                            </div>
                        </div>
                    </div>
                    <div class="search-filter-row">
                        <div class="search-filter-title">
                            {{ $t('common_searchfilter_period') }}
                        </div>
                        <div class="search-filter-content">
                            <div class="date-filter-container-wrapper is-mobile-only">
                                <div class="date-filter-container ">
                                    <div
                                    class="date-filter-item"
                                    :class="searchFilter.selectedDateFilter === 'all' ? 'selected' : ''"
                                    @click="handleDateFilter('all')"
                                    >
                                    {{ $t('common_total') }}
                                    </div>
                                    <div 
                                    v-for="item in searchFilter.dateFilters.slice(0,1)" 
                                    class="date-filter-item"
                                    :class="searchFilter.selectedDateFilter === item ? 'selected' : ''"  
                                    @click="handleDateFilter(item)"
                                    >
                                    {{ item === 'etc' ? $t('common_searchfilter_custom') : `${$t('common_searchfilter_recent')} ${convertMonthAndYearText(item)}` }}
                                    </div>
                                </div>
                                <div class="date-filter-container">
                                    <div 
                                    v-for="item in searchFilter.dateFilters.slice(1,3)" 
                                    class="date-filter-item"
                                    :class="searchFilter.selectedDateFilter === item ? 'selected' : ''"  
                                    @click="handleDateFilter(item)"
                                    >
                                    {{ item === 'etc' ? $t('common_searchfilter_custom') : `${$t('common_searchfilter_recent')} ${convertMonthAndYearText(item)}` }}
                                    </div>
                                </div>
                                <div class="date-filter-container" style="width: 100%;">
                                    <div 
                                    v-for="item in searchFilter.dateFilters.slice(3,4)" 
                                    class="date-filter-item"
                                    :class="searchFilter.selectedDateFilter === item ? 'selected' : ''"  
                                    style="width: 100%;border-bottom: 1px solid rgba(0, 0, 0, 0.15);"
                                    @click="handleDateFilter(item)"
                                    >
                                    {{ item === 'etc' ? $t('common_searchfilter_custom') : `${$t('common_searchfilter_recent')} ${convertMonthAndYearText(item)}` }}
                                    </div>
                                </div>
                            </div>
                            <div class="date-filter-container is-desktop-tablet">
                                <div
                                    class="date-filter-item"
                                    :class="searchFilter.selectedDateFilter === 'all' ? 'selected' : ''"
                                    @click="handleDateFilter('all')"
                                >
                                    {{ $t('common_total') }}
                                </div>
                                <div 
                                    v-for="item in searchFilter.dateFilters" 
                                    class="date-filter-item"
                                    :class="searchFilter.selectedDateFilter === item ? 'selected' : ''"  
                                    @click="handleDateFilter(item)"
                                >
                                    {{ item === 'etc' ? $t('common_searchfilter_custom') : `${$t('common_searchfilter_recent')} ${convertMonthAndYearText(item)}` }}
                                </div>
                            </div>
                            <div class="date-selector-container custom" v-if="searchFilter.selectedDateFilter === 'etc'">
                            <a-range-picker 
                                :allowClear="false" 
                                size="small"
                                :locale="locale" 
                                v-model:value="dateRanges" 
                                @change="search"
                                style="width: 250px; margin-bottom: 10px"
                                @openChange="handleBlur"
                            />
                            </div>
                        </div>
                    </div>
                    <div class="search-filter-row">
                        <div class="search-filter-title">
                            {{ certificateText }} {{ $t('certificatelist_table_status') }}
                        </div>
                        <div class="search-filter-content">
                            <a-select
                            v-model:value="searchFilter.warrantyStatus"
                            @change="handleSelectFilter"
                            size="small"
                            style="width: 150px;"
                            >
                            <a-select-option value="">{{ $t('common_total') }}</a-select-option>
                            <a-select-option
                                v-for="item in WarrantyStatusEnum"
                                :value="item"
                            >
                                {{ convertWarrantyStatusMessage(item) }}
                            </a-select-option>
                            </a-select>
                            <a-select
                              v-model:value="searchFilter.certificateType"
                              size="small"
                              style="width: 120px"
                              placeholder="타입"
                              @change="handleSelectFilter"
                            >
                              <a-select-option value="">전체</a-select-option>
                              <a-select-option value="online">온라인</a-select-option>
                              <a-select-option value="offline">오프라인</a-select-option>
                            </a-select>
                        </div>
                    </div>
                    <!-- 자이스 전용 -->
                    <div class="search-filter-row" v-if="isZeiss">
                        <div class="search-filter-title">
                            {{ $t('certificatelist_table_surgery_item') }}
                        </div>
                        <div class="search-filter-content">
                          <a-checkbox
                            v-model:checked="searchFilter.selectedAllItem"
                            :indeterminate="searchFilter.indeterminate"
                            @change="onCheckAllChange"
                          >
                            {{  $t('hospital_search_all') }}
                          </a-checkbox>
                          <a-checkbox-group 
                            v-model:value="searchFilter.itemCodes"
                            @change="onCheckItemChange"
                          >
                            <a-checkbox 
                              v-for="item in searchFilterItems"
                              :key="item._id"
                              :value="item.itemCode"
                            >
                              {{ item.productType }}
                            </a-checkbox>
                          </a-checkbox-group>
                        </div>
                    </div>
                </div>
                <div class="col-xs-12 table-info-filter">
                    <div class="total-div">
                    <p>
                        {{ $t('common_total') }} <span class="number-highlight">{{ formatCommaNumber(listSize) }}</span>{{ $t('common_case') }}
                    </p>
                    </div>
                    <div class="search-container">
                        <a-select 
                            class="search-select" 
                            v-model:value="rowsPerPage" 
                            @change="handleRowsPerPage"
                            style="width: 150px;"  
                        >
                            <a-select-option :value="10">10{{ $t('common_searchfilter_rowsperpage') }}</a-select-option>
                            <a-select-option :value="20">20{{ $t('common_searchfilter_rowsperpage') }}</a-select-option>
                            <a-select-option :value="50">50{{ $t('common_searchfilter_rowsperpage') }}</a-select-option>
                        </a-select>
                        <a-button 
                            @click="downloadExcelList"
                            type="primary"
                            class="no-mobile"
                        >
                            <template #icon>
                              <i class="fa-solid fa-down-to-bracket"/>
                            </template>
                            {{ $t('common_excel_download') }}
                        </a-button>
                    </div>
                </div>
                <a-table class="ant-table-striped"
                    size="small"
                    :columns="columns"
                    :data-source="responseData"
                    :pagination="false"
                    :customRow="onRowClick"  
                    :rowClassName="setRowClassName"
                    v-if="responseData.length > 0"
                >
                    <template #bodyCell="{ column, record }">
                      <template v-if="column.key === 'certificateType'">
                        <a-tag :color="record.certificateType === 'offline' ? 'blue' : 'default'">
                          {{ record.certificateType === 'offline' ? '오프라인' : '온라인' }}
                        </a-tag>
                      </template>
                    </template>
                </a-table>
                <div class="no-result-container" v-else>
                    <i class="fa-solid fa-exclamation-triangle" />
                    <span>{{ computedNoResultMessage }} </span>
                </div>
            </div>
            <pagination 
              v-if="!$store.state.isLoading && responseData.length > 0"
              :page-info="paginationData"
              page-name="CertificateList"
              @change-page="paginationHandler"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getAccessToken } from '@/utils/tokenStore';
import { 
  jwtDecoder,
  convertDate,
  oneBtnDialog, 
  convertDateTime, 
  formatCommaNumber,
 } from '../utils/utils';
import NoResult from '../views/components/NoResult.vue';
import Pagination from '@/views/components/Pagination.vue';
import locale from 'ant-design-vue/es/date-picker/locale/ko_KR';
import dayjs from "dayjs";
import 'dayjs/locale/ko'

import enums from '@/utils/enums.js'
import { ExportOutlined, ArrowLeftOutlined } from '@ant-design/icons-vue';

export default {
  name: 'certificatelist',
  components: {
    NoResult,
    Pagination,
    ExportOutlined,
    ArrowLeftOutlined
  },
  computed: {
    computedNoResultMessage() {
      if(this.calledApiTimes <= 1) {
        return `${this.$i18n.t('noresult_certificate_1')} ${this.certificateText}${this.$i18n.t('noresult_certificate_2')}`;
      } else {
        return this.$i18n.t('noresult_search');
      }
    },
  },
  data() {
    const page = this;
    return {
      locale,
      dateRanges :[],
      formatCommaNumber,
      convertDateTime,
      isInputFocused: false,
      // 타입
      type: 'HOSPITAL',
      // 목록 받아오는 변수
      responseData: [],
      prevPage: null, // 이전 페이지 경로
      
      isZeiss: false,
      certificateText: this.isZeiss ? this.$i18n.t('common_certificatetext_oph') : this.$i18n.t('common_certificatetext_dent'),
      // 페이지네이션 관련 변수
      previousCondition: '',
      condition: '',
      calledApiTimes: 0,      

      searchFilter: {
        filter: '',
        keyword: '',
        warrantyStatus: '',
        certificateType: '',
        startAt: null,
        endAt: null,
        selectedDateFilter: 'all',
        dateFilters: [3, 12, 36, 'etc'],
        itemCodes: [],
        selectedAllItem: true,
        indeterminate: false,
      },
      searchFilterItems: [],
      columns:[
            {
                key: 'index', title: this.$t('certificatelist_table_no'), dataIndex: 'index', align: 'center', width: "4%",
            },
            {
                key: 'issueMethod', title: this.$t('certificatelist_table_issue_method'), dataIndex: 'issueMethod', align: 'center',
                    customRender: ({text, record}) => {
                        return (
                            <div class="status-chip-wrap">
                                <div
                                className={`status-chip ${this.convertIssueMethodClass(record.issueMethod)}`}
                                >
                                { this.convertIssueMethod(record.issueMethod) || '-' }
                                </div>
                            </div>
                        )
                    },
            },
            { key: 'certificateType', title: '타입', dataIndex: 'certificateType', align: 'center' },
            {
                key: 'createAt', title: this.$t('certificatelist_table_createat'), dataIndex: 'createAt', align: 'start',
                    customRender: ({text, record}) => {
                        return convertDateTime(record.createAt)
                    },
            },
            {
                key: 'productType', title: this.$t('certificatelist_table_code'), dataIndex: 'productType', align: 'start',
                    customRender: ({text, record}) => {
                        return record.productType ? record.productType : '-';
                    },
            },
            {
                key: 'hospitalName', title: this.$t('certificatelist_table_hospital_name'), dataIndex: 'hospitalName', align: 'start',
                    customRender: ({text, record}) => {
                      return record.hospitalName || '-';
                    },
            },
            {
                key: 'address', title: this.$t('certificatelist_table_address'), dataIndex: 'address', align: 'start',
                    customRender: ({text, record}) => {
                      return record.address || '-';
                    },
            },
            {
                key: 'itemName', title: this.$t('certificatelist_table_itemname'), dataIndex: 'itemName', align: 'start',
                    customRender: ({text, record}) => {
                        return record.itemName ? record.itemName : '-';
                    },
            },
            {
                key: 'uniqueCode', title: this.$t('certificatelist_table_productcode'), dataIndex: 'uniqueCode', align: 'start',
            },
            {
                key: 'surgeryAt', title: this.$t('certificatelist_table_surgeryat'), dataIndex: 'surgeryAt', align: 'start',
                    customRender: ({text, record}) => {
                        return convertDate(record.surgeryAt)
                    },
            },
            {
                key: 'issueStatus', title: this.$t('certificatelist_table_status'), dataIndex: 'issueStatus', align: 'center',
                    customRender: ({text, record}) => {
                        return (
                            <div class="status-chip-wrap">
                                <div 
                                className={`status-chip ${this.convertWarrantyStatusClass(record.issueStatus)}`}
                                >
                                { this.convertWarrantyStatusMessage(record.issueStatus) || '-' }
                                </div>
                            </div>
                        )
                    },
            },
        ],
      onRowClick(record, rowIndex) {
          return {
              onClick: event => {
              
                  if(
                    (page.companyId !== process.env.VUE_APP_SEOLBI_OBJECTID)
                    &&  
                    (record.createId === page.companyId)
                  ){
                    page.$router.push({
                        name: 'CustomerDetails',
                        query: { customerId: record.customerId },
                    });
                  }
              },
          };
      },
      listSize: 0,
      rowsPerPage: 10, 
      paginationData: {
        currentPage: 1, 
        totalPages: 0,
      },
      WarrantyStatusEnum: enums().WarrantyStatusEnum,   
      companyId: '',
      
    };
  },
  created() {
    this.companyId = jwtDecoder(getAccessToken());
  },
  async mounted() {
    await this.checkIsZeiss();
    if(this.isZeiss) await this.getSearchFilterItems();

    // 쿼리 파라미터 처리
    const { startDate, endDate, prevPage } = this.$route.query;
    console.log('Query params:', { startDate, endDate, prevPage });

    if (prevPage) {
      this.prevPage = prevPage;
      console.log('prevPage set to:', this.prevPage);
    }

    if (startDate && endDate) {
      this.searchFilter.selectedDateFilter = 'etc';
      this.searchFilter.startAt = dayjs(startDate);
      this.searchFilter.endAt = dayjs(endDate);
      this.dateRanges = [dayjs(startDate), dayjs(endDate)];
      console.log('Date filter set:', this.searchFilter.startAt.format('YYYY-MM-DD'), this.searchFilter.endAt.format('YYYY-MM-DD'));
    }

    const obj = {};
    obj.page = this.paginationData.currentPage;
    this.paginationHandler(obj);
    if(this.companyId === process.env.VUE_APP_INNODTECH_OBJECTID) {
      this.columns.push(
        { 
            key: 'viewDetails', 
            title: '새 창으로 보기', 
            dataIndex: 'viewDetails', 
            align: 'center',
            customRender: ({ text, record }) => {
              return (record.createId === this.companyId ? 
                <div
                  style="width: 100%; display: flex; justify-content: center;"
                >
                    <a-button
                    shape="circle"
                    icon={<ExportOutlined 
                        class="fa-solid fa-ellipsis round-icon"
                        style="cursor: pointer; color:#8D939A; " 
                    />}
                    onClick={(event) => 
                        {
                            event.stopPropagation();
                            this.showCustomerDetailNewWindow(record.customerId)
                        }
                    }
                    />
                </div>
              : <div></div>
            )
          } 
        }
      )
    } else if(this.companyId === process.env.VUE_APP_SEOLBI_OBJECTID) {
      this.columns = this.columns.map(i=>{
        let newDataTitle = i.title;

        if(i.dataIndex == 'hospitalName'){
          newDataTitle = '발행자명'
        }
        if(i.dataIndex == 'itemName'){
          newDataTitle = '보증서명'
        }
        if(i.dataIndex == 'surgeryAt'){
          newDataTitle = '발행 일자'
        }
        return {
          ...i,
          title:newDataTitle
        }
      })
    }
  },
  methods: {
    goBack() {
      if (this.prevPage) {
        this.$router.push(this.prevPage);
      }
    },
    async showCustomerDetailNewWindow(customerId) {
      window.open(`${window.location.href.replaceAll('certificate/list','customer-details')}?customerId=${customerId}`)
    },
    setRowClassName(record){
      console.log(this.companyId === record.companyId)
      if(
        (this.companyId !== process.env.VUE_APP_SEOLBI_OBJECTID)
          &&
        (record.createId === this.companyId)
      ){
        return 'hover-pointer';
      }
      return '';
    },
    convertDate,
    handleBlur(open) {
      console.log('blur', open)
    },
    checkIsZeiss() {
      if(this.companyId && this.companyId === process.env.VUE_APP_ZEISS_ID) {
        this.isZeiss = true;
      }
    },
    async paginationHandler(childPassParam) {
      this.paginationData.currentPage = childPassParam.page;
      await this.getCertificateList();    
    },
    // 주요 API
    // 전체 목록 가져오기
    async getSearchFilterItems() {
      try {
          const response = await this.$apiInstance.get(`/items`);
          if (response.status === 200 || response.status === 201) {
            if(response.data.docs) {
                this.searchFilterItems = response.data.docs;
                this.searchFilter.itemCodes = this.searchFilterItems.sort((a, b) => new Date(a.createAt) - new Date(b.createAt)).map(item => item.itemCode);
            } else {
                this.searchFilterItems = [];
            }
          }
        } catch (error) {
          console.log(error);
      }
    },
    async onCheckAllChange(event) {
      const checked = event.target.checked;
      this.searchFilter.itemCodes = checked ? this.searchFilterItems.map(item => item.itemCode) : [];
      this.searchFilter.indeterminate = false;

      await this.getCertificateList();
    },
    async onCheckItemChange(event) {
      const totalItems = this.searchFilterItems.length;
      const selectedItems = this.searchFilter.itemCodes.length;

      this.searchFilter.selectedAllItem = selectedItems === totalItems;
      this.searchFilter.indeterminate = selectedItems > 0 && selectedItems < totalItems;

      console.log(this.searchFilter.itemCodes)

      await this.getCertificateList();
    },
    async getCertificateList() {
      const obj = {};
      obj.page = this.paginationData.currentPage;
      obj.limit = this.rowsPerPage;
      obj.search = this.searchFilter.filter;
      obj.condition = this.searchFilter.keyword;
      
      if(this.dateRanges?.length ==2){
        obj.startAt = dayjs(this.dateRanges[0]).format("YYYYMMDD");
        obj.endAt = dayjs(this.dateRanges[1]).format("YYYYMMDD");
      }else{
        obj.startAt = null;
        obj.endAt = null;
      }
      if(this.isZeiss) {
        obj.itemCodes = this.searchFilter.itemCodes.map(item => item)
      }
      obj.issueStatus = this.searchFilter.warrantyStatus;
      obj.certificateType = this.searchFilter.certificateType;
      this.$store.commit('setIsLoading', true);
      try {
        const response = await this.$apiInstance.post(`/nfts/manufacturer/list/v2`, obj);
        if (response.status === 200 || response.status === 201) {
          this.calledApiTimes ++;
          if(response.data.docs) {
            this.responseData = response.data.docs;
          } else {
            this.responseData = [];
          }
          this.listSize = response.data.totalDocs;
          
          for (let i = 0; i < this.responseData.length; i++) {
            this.responseData[i].index =
              this.listSize - i - (this.paginationData.currentPage - 1) * this.rowsPerPage;
          }

          this.paginationData.totalPages = response.data.totalPages;
          this.$store.commit('setIsLoading', false);
        }
      } catch (error) {
        console.log(error);
        this.$store.commit('setIsLoading', false);
        await oneBtnDialog(`${this.certificateText} ${this.$i18n.t('certificatelist_list_fail_title')}`, 
        `${this.certificateText} ${this.$i18n.t('certificatelist_list_fail_content')} `, 
        false);
      }
    },

    async downloadExcelList() {
      if(this.responseData.length === 0) {
        await oneBtnDialog(this.$i18n.t('certificatelist_list_empty_title'),this.$i18n.t('certificatelist_list_empty_content'), false);
        return;
      }
      
      const formattedDate = dayjs().format("YYYYMMDD");

      const obj = {};
      obj.search = this.searchFilter.filter;
      obj.condition = this.searchFilter.keyword;
      if(this.searchFilter.startAt && this.searchFilter.startAt) {
        obj.startAt = this.unixTimeToYYYYMMDD(this.searchFilter.startAt);
        obj.endAt = this.unixTimeToYYYYMMDD(this.searchFilter.endAt);
      }
      
      if (this.dateRanges?.length == 2) {
        obj.startAt = dayjs(this.dateRanges[0]).format("YYYYMMDD");
        obj.endAt = dayjs(this.dateRanges[1]).format("YYYYMMDD");
      } else {
        obj.startAt = null
        obj.endAt = null
      }
      if(this.isZeiss && this.searchFilter.itemCodes.length > 0) {
        obj.itemCodes = this.searchFilter.itemCodes.map(item => item)
      }
      obj.certificateType = this.searchFilter.certificateType;
      try {
        this.$store.commit('setIsLoading', true);
        const response = await this.$apiInstance.post(
            `/nfts/manufacturer/list/excel`,obj,
            {
              headers: {
                'Content-Type': 'application/json',
              },
              responseType: 'blob',
            }
        );

        if (response.status === 200 || response.status === 201) {
          const blob = new Blob([response.data], {
            type: 'application/octet-stream',
          });

          const url = URL.createObjectURL(blob);

          const downloadLink = document.createElement('a');
          downloadLink.href = url;
          downloadLink.download = `${this.$i18n.t('certificatelist_list_filename')}_${formattedDate}.xlsx`;
          downloadLink.click();

          URL.revokeObjectURL(url);
        } else {
          // Handle the error case
        }
        this.$store.commit('setIsLoading', false);
      } catch (error) {
        this.$store.commit('setIsLoading', false);
        console.error('error: ', error);
        if (error.response && error.response.status === 404) {
            if (error.response.data instanceof Blob) {
                const reader = new FileReader();
                reader.readAsText(error.response.data);
                reader.onload = async () => {
                    try {
                        const errorData = JSON.parse(reader.result);
                        await oneBtnDialog(this.$i18n.t('certificatelist_list_empty_title'), errorData.message, false);
                    } catch {
                        await oneBtnDialog(this.$i18n.t('certificatelist_list_empty_title'), this.$i18n.t('certificatelist_list_excel_error'), false);
                    }
                };
                reader.onerror = async () => {
                    await oneBtnDialog(this.$i18n.t('certificatelist_list_empty_title'), this.$i18n.t('certificatelist_list_excel_error'), false);
                };
            } else {
                await oneBtnDialog(this.$i18n.t('certificatelist_list_empty_title'), this.$i18n.t('certificatelist_list_excel_error'), false);
            }
        } else {
            await oneBtnDialog(this.$i18n.t('certificatelist_list_empty_title'), this.$i18n.t('certificatelist_list_excel_error'), false);
        }
      }
    },


    async search() {
      if(!await this.validateSearchFilter()) return;
      this.paginationData.currentPage = 1;
      await this.getCertificateList();
    },
    async searchAllPeriod() {
      this.paginationData.currentPage = 1;
      this.searchFilter.startAt = null;
      this.searchFilter.endAt = this.getCurrentUnixTime();
      await this.getCertificateList();
    },
    async initFilter() {
      this.dateRanges = [];
      this.searchFilter = {
        filter: '',
        keyword: '',
        warrantyStatus: '',
        certificateType: '',
        startAt: null,
        endAt: null,
        selectedDateFilter: 'all',
        dateFilters: [3, 12, 36, 'etc'],
        itemCodes: [],
        selectedAllItem: true,
        indeterminate: false,
      }
      if(this.isZeiss) this.searchFilter.itemCodes = this.searchFilterItems.map(item => item.itemCode);
      await this.getCertificateList();
    },
    handleStartAt(value) {
      this.paginationData.currentPage = 1;
      this.searchFilter.startAt = value;
      this.search();
    },
    handleEndAt(value) {
      this.paginationData.currentPage = 1;
      this.searchFilter.endAt = value;
      this.search();
    },
    handleSelectFilter() {
      this.paginationData.currentPage = 1;
      this.search();
    },
    handleDateFilter(value) {
      console.log('handle', value)
      this.paginationData.currentPage = 1;
      if(value === this.searchFilter.selectedDateFilter) return;
      
      this.searchFilter.selectedDateFilter = value;
      if (value === 'all') {
        this.searchFilter.startAt = null;
        this.searchFilter.endAt = null;
      } else {
        this.searchFilter.startAt = this.getPastDatesInUnixTime(value);
        this.searchFilter.endAt = dayjs().valueOf();
      }
      if(this.searchFilter.startAt !== null){
        this.dateRanges[0] = dayjs(this.searchFilter.startAt)
      }else{
        this.dateRanges = [];
      }
      if(this.searchFilter.endAt !== null){
        this.dateRanges[1] = dayjs(this.searchFilter.endAt)
      }else{
        this.dateRanges = [];
      }
      this.search();
    },
    getCurrentUnixTime() {
      return dayjs().valueOf();
    },
    getPastDatesInUnixTime(value) {
      switch(value) {
        case 3:
          return dayjs().subtract(3, 'month').valueOf();
        case 12:
          return dayjs().subtract(12, 'month').valueOf();
        case 36:
          return dayjs().subtract(36, 'month').valueOf();
        default:
          return dayjs().valueOf();
      }
    },
    unixTimeToYYYYMMDD(unixTime) {
      return dayjs(unixTime).format('YYYYMMDD');
    },
    async validateSearchFilter() {
      // 필터 걸어놓고 검색을 안함
      // 시작날짜가 과거날짜보다 큼

      if(this.searchFilter.startAt && !this.searchFilter.endAt) {
        return false;
      }
      if(this.searchFilter.startAt > this.searchFilter.endAt) {
        await oneBtnDialog(this.$i18n.t('certificatelist_list_dateerr_title'), this.$i18n.t('certificatelist_list_dateerr_content'));
        return false;
      }
      return true;
    },
    convertMonthAndYearText(input) {
      if(input < 12) return `${input}${this.$i18n.t('common_searchfilter_month')}`;
      return `${input / 12}${this.$i18n.t('common_searchfilter_year')}`;
    },




    async handleRowsPerPage() {
      this.paginationData.currentPage = 1;
      await this.getCertificateList();
    },
    async enter() {
      if (!this.searchFilter && this.condition) {
        await oneBtnDialog(
            this.$i18n.t('certificatelist_search_empty_filter_err_title'),
            this.$i18n.t('certificatelist_search_empty_filter_err_content'),
            false
        );
      } else {
        this.paginationData.currentPage = 1;
        this.getCertificateList();
      }
    },
    // 인증서 상태 코드 텍스트로 변환

    convertIssueMethod(input) {
      switch(input) {
        case 'single':
        return this.$i18n.t('certificatelist_list_single');
        case 'bulk':
        return this.$i18n.t('certificatelist_list_bulk');
      }
    },
    convertIssueMethodClass(input) {
      switch(input) {
        case 'single':
        return 'single';
        case 'bulk':
        return 'bulk';
      }
    },


    convertWarrantyStatusMessage(input) {
      const { WarrantyStatusEnum } = enums();
      switch(input) {
        case WarrantyStatusEnum.REQUEST_ISSUED:
        return this.$i18n.t('warranty_request_issued');
        case WarrantyStatusEnum.ISSUED:
        return this.$i18n.t('warranty_issued');
        case WarrantyStatusEnum.DISPOSED:
        return this.$i18n.t('warranty_disposed');
        case WarrantyStatusEnum.RETURNED:
        return this.$i18n.t('warranty_returned');
        case WarrantyStatusEnum.BIZ_SEND_ERROR:
        return this.$i18n.t('warranty_bizerror');
        case WarrantyStatusEnum.SEND_LMS:
        return this.$i18n.t('warranty_lms');
        case WarrantyStatusEnum.SEND_BIZ:
        return this.$i18n.t('warranty_kakao');
        case WarrantyStatusEnum.WECHAT_ISSUED:
        return this.$i18n.t('wechat_issued');
        default:
        return '-';
      }
    },
    convertWarrantyStatusClass(input) {
      const { WarrantyStatusEnum } = enums();
      switch(input) {
        case WarrantyStatusEnum.REQUEST_ISSUED:
        return WarrantyStatusEnum.REQUEST_ISSUED;
        case WarrantyStatusEnum.ISSUED:
        return WarrantyStatusEnum.ISSUED;
        case WarrantyStatusEnum.DISPOSED:
        return WarrantyStatusEnum.DISPOSED;
        case WarrantyStatusEnum.RETURNED:
        return WarrantyStatusEnum.RETURNED;
        case WarrantyStatusEnum.BIZ_SEND_ERROR:
        return WarrantyStatusEnum.BIZ_SEND_ERROR;
        case WarrantyStatusEnum.SEND_LMS:
        return WarrantyStatusEnum.SEND_LMS;
        case WarrantyStatusEnum.SEND_BIZ:
        return WarrantyStatusEnum.SEND_BIZ;
        case WarrantyStatusEnum.WECHAT_ISSUED:
        return WarrantyStatusEnum.WECHAT_ISSUED;
        default:
        return '';
      }
    },

    convertIssueType(code) {
      const i18n = this.$i18n;
      switch (code) {
        case 'Y':
          return i18n.t('certificatelist_issued');
        case 'N':
          return i18n.t('certificatelist_unissued');
        default:
          return '-';
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.search-filter-content{
  .mobile-wrap{
    display: flex;
    gap: 8px;
  }
  .mobile-no-wrap{
    display: flex;
  }
}
@media screen and (max-width:767px) {
  .date-selector-container,
  .ant-picker.ant-picker-range{
    width: 100% !important;
  }
  .search-filter-content .date-filter-container-wrapper{
    display: flex;
    flex-direction: column;
    width: 100%;
    .date-filter-container{
      flex-direction: row;
      border-radius: 0;
      border-bottom:0;
      .date-filter-item{
        width: 50%;
        border-bottom:0;
      }
    }
  }
  .container-fluid .row.justify-content-center{
    padding: 14px 14px 36px 14px !important;
  }
  .mainDiv{
    width: 100% !important;
  }
  .search-filter-title{
    margin-right: auto;
    width: auto;
    margin-left: 10px;
  }
  .search-filter-content .mobile-wrap{
    width: 100%;
  }
  .search-filter-content .search-select{
    width: 100px;
  }
  .search-filter-content .search-input-container{
    width: calc(100% - 100px);
    display: flex;
    justify-content: flex-start;
    input{
      width: 100%;
    }
  }
  .search-filter-content .date-filter-container{
    height: auto;
  }
  .search-filter-content .date-selector-container.custom{
    flex-direction: column;
    height: auto;
    align-items: center;
  }
  .search-filter-content .date-filter-container{
    flex-direction: column;
  }
  .search-filter-row{
    height: auto;
  }
  .search-filter-row,
  .search-filter-content{
    flex-direction: column;
    flex: none;
  }
  .card-header{
    margin: 0;
  }
}

@media screen and (min-width:768px) and (max-width:1023px){
  .search-filter-title{
    width: 100%;
    justify-content: flex-start;
    margin-left: 20px;
  }
  
  .table-with-search .table-info-filter{
    flex-direction: column;
    width: 100%;
    .total-div{
      margin-right: auto;
    }
    .search-container{
      width: 100%;
      flex-direction: row;
      .search-select{
        margin-right: auto;
      }
      .search-div{
        flex-direction: row;
        width: 100%;
        input{
          width: calc(100% - 80px) !important;
        }
        .search-btn{
          min-width: 80px;
        }
      }
    }
  }
  .search-filter-row{
    flex-direction: column;
    height: auto;
    &:nth-of-type(2){
      .search-filter-content{
        flex-direction: column;
      }
      .search-filter-content{
        align-items: flex-start;
      }
      .date-selector-container.custom{
        display: flex;
        align-items: center;
        justify-content: flex-start;
        width: 100%;
      }
    }
  }
}

label {
  font-weight: 500;
}
</style>
<style>
.hover-pointer{
  cursor: pointer;
}
</style>